import {create} from '@wix/fedops-logger';
let logger;
let created = false;

function init() {
  if (created || logger !== undefined) {
    return;
  }
  created = true;
  logger = create('marketing-release-notes');
}

function appLoaded() {
  if (logger) {
    logger.appLoaded();
  }
}

export default {
  appLoaded,
  init
};
